import { ValidationError } from "sequelize"
import {
    CcRequirementTempAnswer,
    CcRequirementTempAnswerVersion,
} from "server/models"
import { GET, POST, DELETE, validate } from "client/store/utils"
import {
    LangType,
    RequirementTempAnswerByUser,
    RequirementTempAnswerVersionByUser,
    RequirementTempAnswerValidation,
} from "client/store"

// temp answer

export const LoadCcRequirementTempAnswers = (
    requirementId: number,
    revisionId: number,
) => (
    GET(`/ccRequirementTempAnswer/requirement/${requirementId}/revision/${revisionId}`)
    .then((answers: CcRequirementTempAnswer[]) => {
        const tempAnswers: RequirementTempAnswerByUser = {}
        answers.forEach((answer) => {
            tempAnswers[answer.editorId] = answer
        })
        return tempAnswers
    })
)
export const SaveCcRequirementTempAnswer = (
    answer: CcRequirementTempAnswer,
    lang: LangType,
) => (
    POST(
        "/ccRequirementTempAnswer/save",
        JSON.stringify(answer),
    ).then((res) => {
        const error = res as ValidationError
        const validation = <RequirementTempAnswerValidation>validate(error, lang)
        return validation
    })
)
export const DeleteCcRequirementTempAnswers = (requirementId: number, revisionId: number) => (
    DELETE(`/ccRequirementTempAnswer/delete/requirement/${requirementId}/revision/${revisionId}`)
    .then((removedRows: number) => removedRows)
)

// temp answer versions

export const LoadCcRequirementTempAnswerVersions = (
    requirementId: number,
    revisionId: number,
) => (
    GET(`/ccRequirementTempAnswerVersion/requirement/${requirementId}/revision/${revisionId}`)
    .then((versions: CcRequirementTempAnswerVersion[]) => {
        const tempVersions: RequirementTempAnswerVersionByUser = {}
        versions.forEach((version) => {
            if (!tempVersions[version.editorId]) tempVersions[version.editorId] = []
            tempVersions[version.editorId].push(version)
        })
        return tempVersions
    })
)
export const SaveCcRequirementTempAnswerVersions = (versions: CcRequirementTempAnswerVersion[]) => (
    POST(
        "/ccRequirementTempAnswerVersion/save",
        JSON.stringify(versions),
    )
)
export const DeleteCcRequirementTempAnswerVersions = (
    requirementId: number,
    revisionId: number,
    editorId: number,
) => (
    DELETE(`/ccRequirementTempAnswerVersion/delete/requirement/${requirementId}/revision/${revisionId}/editor/${editorId}`)
    .then((removedRows: number) => removedRows)
)
